export const borderColor = '1px solid #eaeaea'
